import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/* global initialState */
/* global contextPath */

export default new Vuex.Store({
  state: JSON.parse(initialState),
  mutations: {
    requestedScopes (state, data) {
      state.requestedScopes = data
      console.debug(`requestedScopes updated [requestedScopes=${data}]`)
    },
    username (state, username) {
      if (checkIfEmpty('username', username)) return
      if (state.username === username) return

      username = username.replace(/\s/g, '')
      username = username.replace(/＠/g, '@')

      state.username = username

      console.debug(`username updated [username=${username}]`)
    },
    unconfirmedUsername (state, unconfirmedUsername) {
      if (checkIfEmpty('unconfirmedUsername', unconfirmedUsername)) return
      if (state.unconfirmedUsername === unconfirmedUsername) return

      unconfirmedUsername = unconfirmedUsername.replace(/\s/g, '')
      unconfirmedUsername = unconfirmedUsername.replace(/＠/g, '@')

      state.unconfirmedUsername = unconfirmedUsername

      console.debug(`unconfirmedUsername updated [unconfirmedUsername=${unconfirmedUsername}]`)
    },
    uid (state, uid) {
      if (checkIfEmpty('uid', uid)) return
      if (state.uid === uid) return

      state.uid = uid
      console.debug(`uid updated [uid=${uid}]`)
    },
    country (state, country) {
      if (checkIfEmpty('country', country)) return
      if (state.country === country) return

      state.country = country
      console.debug(`country updated [country=${country}]`)
    },
    lang (state, payload) {
      if (checkIfEmpty('lang', payload)) return
      if (checkIfEmpty('lang', payload.lang)) return
      if (state.lang === payload.lang) return

      state.lang = payload.lang
      console.debug(`lang updated [lang=${payload.lang}]`)

      if (payload.lang === payload.i18n.locale) return

      console.debug(`Loading language translations [language=${payload.lang}]`)

      const language = payload.lang.replace('_', '-')

      $.getJSON(contextPath + '/translation/json?lang=' + language, function (data) {
        payload.i18n.setLocaleMessage(language, data)
        payload.i18n.locale = language
      })
    },
    brand (state, brand) {
      if (checkIfEmpty('brand', brand)) return
      if (state.brand === brand) return

      state.brand = brand
      console.debug(`brand updated [brand=${brand}]`)
    },
    deviceData  (state, deviceInfo) {
      if (checkIfEmpty('deviceData', deviceInfo)) return
      if (state.deviceData === deviceInfo) return

      state.deviceData = deviceInfo
      console.debug(`deviceData updated [deviceInfo=${deviceInfo}]`)
    },
    remainingCooldown (state, timeInSeconds) {
      if (checkIfEmpty('remainingCooldown', timeInSeconds)) return

      state.remainingCooldown = timeInSeconds
      console.debug(`remainingCooldown updated [timeInSeconds=${timeInSeconds}]`)
    }
  },
  actions: {
  },
  modules: {
  }
})

function checkIfEmpty (name, data) {
  if (data) {
    return false
  }

  console.warn(`${name} can't be empty in store`)
  return true
}
